
$(function() {
    $('.productSlider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      arrows: true,
      autoplaySpeed: 2000,
      responsive: [
    {
      breakpoint: 769,
      settings: {
      slidesToShow: 2,
      centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
      slidesToScroll: 1
      }
      },
     {
      breakpoint: 600,
      settings: {
      slidesToShow: 2,
      centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
      slidesToScroll: 1
      }
    }
   ]
  });
}); 

